<template>

  <div class="container h-100">
    <Loading :active.sync="isLoading"
             :is-full-page="isFullPage"></Loading>
    <b-alert variant="danger"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{alertMessage}}
    </b-alert>
    <div class="row d-flex h-100 justify-content-center">
      <div class="text-center mb-4 ">
        <b-img fluid src="../assets/images/login.jpg"/>
        <h1 class="h3 mb-3 font-weight-normal text-center">sinavanaliz.ankaradil.com</h1>
        <p class="text-center">sinavanaliz.ankaradil.com ile YDS sınavınızı değerlendirin.</p>
        <p class="text-center">Ankara Dil Akademisi 'ne ait tüm site ve mobil uygulamalarda aynı eposta adresi ve şifreyi kullanabilirsiniz. Eğer daha önce www.ankaradil.com adresi üzerinden üye olduysanız  <router-link to="/login">Giriş Yap 'a</router-link>  tıklayarak sisteme giriş yapabilirsiniz.</p>
      </div>
    <div class="col-md-6">
    <form class="form-signin ">
      <div class="form-label-group">
        <label class="h6" for="inputEmail">Eposta Adresi</label>
        <input v-model="username" type="email" id="inputEmail" class="form-control" placeholder="Eposta Adresi" required="" autofocus="">

      </div>
      <div class="form-label-group">
        <label  class="h6" for="inputPassword">Şifre</label>
        <input v-model="password" type="password"  id="inputPassword" class="form-control" placeholder="Şifre" required="">
      </div>

      <div class="form-label-group">
        <label  class="h6" for="inputRePassword">Şifre Tekrar</label>
        <input v-model="repassword" type="password" id="inputRePassword" class="form-control" placeholder="Şifre Tekrar" required="">
      </div>

      <div class="form-label-group">
        <label  class="h6" for="inputEmail">Adınız</label>
        <input v-model="adi"  type="text" id="inputAd" class="form-control" placeholder="Adınız" required="" >

      </div>

      <div class="form-label-group">
        <label   class="h6" for="inputEmail">Soyadınız</label>
        <input v-model="soyadi" type="text" id="inputSoyad" class="form-control" placeholder="Soyadınız" required="">

      </div>
      <div class="checkbox mb-3">
        <label>
          <!--<input type="checkbox" value="remember-me"> Remember me-->
         </label>
      </div>
      <button  class="btn btn-lg btn-primary btn-block" v-on:click="signin" >Üye Ol</button>
      <p class="mt-5 mb-3 text-muted text-center">© 2018 <a href="http://www.code4edu.com">code4edu.com</a></p>
    </form>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'UyeOl',
  data: () => {
    return {
      username: '',
      password: '',
      repassword: '',
      adi: '',
      soyadi: '',
      showDismissibleAlert: false,
      alertMessage: '',
      isLoading: false,
      isFullPage: true
    }
  },
  components: {
    Loading
  },
  methods: {
    ...mapActions([
      'Login_ACTION'
    ]),
    test: function (e) {
      console.log('Test')
      e.preventDefault()
    },
    signin: function (e) {
      this.isLoading = true
      this.showDismissibleAlert = false
      if (this.password !== this.repassword) {
        this.alertMessage = 'Girdiğiniz şifreler uyuşmuyor. Lütfen kontrol edip yeniden deneyin.'
        this.showDismissibleAlert = true
        this.isLoading = false
        return
      }
      if (!this.username || !this.username || !this.adi || !this.soyadi || !this.password || !this.repassword) {
        this.alertMessage = 'Tüm alanların doldurulması zorunludur.'
        this.showDismissibleAlert = true
        this.isLoading = false
        return
      }
      const instance = axios.create({
        baseURL: this.$serviceAddres,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
          'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
        }
      })
      instance.post(this.$serviceAddress + 'api/v5/addUser', {
        email: this.username,
        ad: this.adi,
        soyad: this.soyadi,
        password: this.password,
        group: 21
      }, {
        crossdomain: true,
        auth: {
          username: this.username,
          password: this.password
        }
      }).then(response => {
        let data = response.data
        this.isLoading = false
        if (data.result === 1) {
          data.router = this.$router
          this.Login_ACTION(data)
          // this.$router.push('UserMain')
        } else {
          this.alertMessage = 'Kullanıcı Oluşturulurken bir hata oluştu :' + data.err
          this.showDismissibleAlert = true
        }
      })
        .catch(e => {
          this.isLoading = false
          this.alertMessage = 'Kullanıcı Oluşturulurken bir hata oluştu :' + e.message
          this.showDismissibleAlert = true
        })

      e.preventDefault()
    }
  }
}
</script>

<style scoped>
  .form-label-group{
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UyeOl.vue